/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';
import { CustomPart } from '../models';
import { CollectionQueryOptions } from '../types';
import { useCollection } from './useCollection';
import { useCollectionGroup } from './useCollectionGroup';

export function useCompanyCustomParts(
  companyId: string,
  options?: CollectionQueryOptions
) {
  return useCollection<CustomPart>(
    `Companies/${companyId}/CustomParts`,
    [],
    options?.sorting || { sortField: 'id', sortDirection: 'desc' },
    options?.pagination,
    options?.filters
  );
}

export function useCompaniesCustomParts(options?: CollectionQueryOptions) {
  const { list, ...rest } = useCollectionGroup<CustomPart>(
    'CustomParts',
    [],
    options?.sorting || { sortField: 'id', sortDirection: 'desc' },
    options?.pagination,
    options?.filters
  );

  const uniqueData = useMemo(() => {
    const seen = new Set();
    return list.filter((item) => {
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
  }, [list]);

  return { list: uniqueData, ...rest };
}
